import { render, staticRenderFns } from "./investimentoTable.vue?vue&type=template&id=58142998&"
import script from "./investimentoTable.vue?vue&type=script&lang=js&"
export * from "./investimentoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports